import { CARDS_EXTENSION_TYPE } from '@atlassian/cards-extension';
import { carouselExtensionType } from '@atlassian/carousel-extension';
import {
	KNOWLEDGE_CARDS_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SPOTLIGHT_EXTENSION_TYPE,
} from '@atlassian/company-hub-common';
import { SEARCH_EXTENSION_TYPE } from '@atlassian/custom-search-extension';
import { LINKS_MENU_EXTENSION_TYPE } from '@atlassian/links-menu-extension';
import { PAGE_TOPPER_EXTENSION_TYPE } from '@atlassian/page-topper-extension';

export const ALLOWED_EXTENSIONS = [
	SPOTLIGHT_EXTENSION_TYPE,
	CARDS_EXTENSION_TYPE,
	LINKS_MENU_EXTENSION_TYPE,
	SECTION_EXTENSION_TYPE,
	SEARCH_EXTENSION_TYPE,
	carouselExtensionType,
	KNOWLEDGE_CARDS_EXTENSION_TYPE,
	PAGE_TOPPER_EXTENSION_TYPE,
];
